// src/pages/sow-template/TemplatePreviewModal.jsx
import PropTypes from "prop-types";
import { Button, Modal } from "../../shared/ui";
import "./sowTemplatePreview.css";

export default function TemplatePreviewModal({ open, onClose, templateName, html }) {
  return (
    <Modal
      open={open}
      title={templateName ? `Template Preview: ${templateName}` : "Preview"}
      onClose={onClose}
      size="lg"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="sow-preview" style={{ maxHeight: "70vh", overflowY: "auto" }} dangerouslySetInnerHTML={{ __html: html }} />
    </Modal>
  );
}

TemplatePreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  templateName: PropTypes.string,
  html: PropTypes.string,
};
